export default __webpack_public_path__ + "static/media/password.621eea33.svg";